module.exports = __webpack_public_path__ + "static/img/nu.c5c46b88.svg";